/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAnalytics } from 'libs/utils/site/analytics';
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { OverflowFilters } from 'pages/custom/shared/overflow/OverflowFilters';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

const ACCO_SET = 'F81cf7c78-876b-4234-98e5-d155976845e5';
const SIGHT_SET = '672bdf53-6523-4294-b456-ee62af87156c';
const ATTR_SET = '283ec70c-6c1f-4489-980a-661048f8e455';
const REST_SET = '259df23e-1c6e-4437-8440-6609734d681d';
const ACTI_SET = 'a21683a3-6125-458b-b28b-2c3b93af91b5';

export const FredrikstadPage = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);
    const ctxModal = useContext(CtxModal);
    const analytics = useAnalytics();

    function setAllVisible() {
        ctxModal.setShowListOfStories(false);
        ctxView.setVisibleMapSetIds([ACCO_SET, SIGHT_SET, ATTR_SET, REST_SET, ACTI_SET]);
        analytics.track('custom_button.clicked', {
            action: 'filter.reset'
        });
    }

    function setVisibleMapSet(mapSetId: string) {
        ctxModal.setShowListOfStories(false);
        ctxView.setVisibleMapSetIds([mapSetId]);
        analytics.track('custom_button.clicked', {
            action: 'filter.select',
            categoryId: mapSetId
        });
    }

    function isSetHighlighted(mapSetId: string) {
        return ctxView.visibleMapSetIds.length === 1 && ctxView.visibleMapSetIds[0] === mapSetId;
    }

    return (
        <S_FredrikstadPage className={props.className}>
            <CustomMapPage
                mapId={'d1fa2322-f383-4e55-b79c-c43baf3e6ff0'}
                topOverflow={
                    <OverflowFilters
                        highlightedBackground="linear-gradient(88.56deg,#bc4e4e 0%,#a31616 100%)"
                        items={[
                            {
                                iconName: 'location-dot',
                                text: Localization.ALL,
                                onClick: setAllVisible,
                                highlighted: ctxView.visibleMapSetIds.length === 5
                            },
                            {
                                iconName: 'binoculars',
                                text: 'Sightseeing',
                                onClick: () => {
                                    setVisibleMapSet(SIGHT_SET);
                                },
                                highlighted: isSetHighlighted(SIGHT_SET)
                            },
                            {
                                iconName: 'camera',
                                text: 'Attractions',
                                onClick: () => {
                                    setVisibleMapSet(ATTR_SET);
                                },
                                highlighted: isSetHighlighted(ATTR_SET)
                            },
                            {
                                iconName: 'utensils',
                                text: 'Restaurants',
                                onClick: () => {
                                    setVisibleMapSet(REST_SET);
                                },
                                highlighted: isSetHighlighted(REST_SET)
                            },
                            {
                                iconName: 'bolt',
                                text: 'Activities',
                                onClick: () => {
                                    setVisibleMapSet(ACTI_SET);
                                },
                                highlighted: isSetHighlighted(ACTI_SET)
                            }
                        ]}
                    />
                }
            />
        </S_FredrikstadPage>
    );
};

const S_FredrikstadPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
